import { jobStatusNames } from '../../common/constants/jobStatusNames';

const { New, InProgress, Processed, Verification, Done, Rejected } = jobStatusNames;

/**
 * SC-QA-127: the status moves the API allows, per role: the same map as dealer-api
 * `src/jobs/helpers/status-transitions.ts` (SC-QA-25), which refuses any other with 400 `STATUS_TRANSITION_NOT_ALLOWED`.
 * A Super Admin may make every dealer move plus their own; Paid to dealer is not a status we use, so it has no entry.
 * Keep the two in step: a test locks this copy's pairs.
 */
export const STATUS_TRANSITIONS = {
    [New]: { dealer: [InProgress, Rejected], superAdmin: [] },
    [InProgress]: { dealer: [New, Processed, Rejected], superAdmin: [] },
    [Processed]: { dealer: [InProgress], superAdmin: [Verification, Done, Rejected] },
    [Verification]: { dealer: [], superAdmin: [Processed, Done, Rejected] },
    [Done]: { dealer: [], superAdmin: [Verification] },
    [Rejected]: { dealer: [], superAdmin: [] },
};

export const canChangeStatus = (from, to, isSuperAdmin) => {
    const moves = STATUS_TRANSITIONS[from];
    if (!moves) return false;
    return moves.dealer.includes(to) || (Boolean(isSuperAdmin) && moves.superAdmin.includes(to));
};

// The API's answers to a status change this file has texts for, or null for any other error.
export const statusChangeErrorCode = error => {
    const code = error?.response?.data?.code;
    return code === 'JOB_ALREADY_TAKEN' || code === 'STATUS_TRANSITION_NOT_ALLOWED' ? code : null;
};
